import { DocumentPropertiesList } from '@pages/map/actions/DocumentPropertiesList';
import { DocumentsImagesPanelThumbnails } from '@shared/documents-images/ui/DocumentsImagesPanelThumbnails';
import { DocumentInfoPanel, DocxViewer, PdfOrExternalViewer } from '@shared/documents/ui/DocumentViewers';
import { VideoViewer } from '@shared/documents/ui/VideoViewer';
import { Events } from '@shared/Events';
import { TreeNode } from '@shared/ui-native/Tree';
import { Button } from '@shared/ui-react/Button';
import { cs } from '@shared/utils/utils-classname';
import * as React from 'react';
import './DocumentViewerWithNavigation.scss';
import { Telemetry, TelemetryEventType, TelemetrySource } from '@shared/Telemetry';
import { isVideoExtension } from '@shared/utils/FileTypeUtils';

export class DocumentViewerWithNavigation extends React.Component<
    {
        initialId: number;
        queue: IDocument[];
        onEdit: (item: IDocument) => void;
        onOpen: (uuid: string) => void;
        getFolderTreeNode: (folderId: number) => TreeNode;
        onOpenFolderId: (folderId: number, documentId: number) => void;
        onCenter: (item: IDocument) => void;
        onChange: (item: IDocument) => void;
    },
    {
        currentIndex: number;
        showQueueThumbnails?: boolean;
        showFillControls?: boolean;
    }
> {
    static defaultProps = {
        queue: [],
    };

    state = {
        currentIndex: this.props.initialId ? this.props.queue.findIndex(i => i.id === this.props.initialId) : 0,
        showQueueThumbnails: false,
        showFillControls: false,
    };

    componentDidMount() {
        Telemetry.add(TelemetryEventType.MAP_DOC_POPUP_VIEW, TelemetrySource.MAP_2D_DESKTOP);
    }

    componentWillUnmount() {
        Events.trigger('map-highlight-clear');
    }

    goNext = () =>
        this.setState(
            prevState => ({
                currentIndex: (prevState.currentIndex + 1) % this.props.queue.length,
                showQueueThumbnails: false,
            }),
            this.triggerOnChange
        );

    goPrev = () =>
        this.setState(
            prevState => ({
                currentIndex: (prevState.currentIndex - 1 + this.props.queue.length) % this.props.queue.length,
                showQueueThumbnails: false,
            }),
            this.triggerOnChange
        );

    goFirst = () => this.setState({ currentIndex: 0, showQueueThumbnails: false }, this.triggerOnChange);

    goLast = () => this.setState({ currentIndex: this.props.queue.length - 1, showQueueThumbnails: false }, this.triggerOnChange);

    setIndexById = (imageId: number) => {
        const index = this.props.queue.findIndex(i => i.id === imageId);
        this.setState({ currentIndex: index, showQueueThumbnails: false }, this.triggerOnChange);
    };

    toggleQueueThumbnails = () => {
        this.setState({ showQueueThumbnails: !this.state.showQueueThumbnails });
    };

    toggleFillControls = () => {
        this.setState({ showFillControls: !this.state.showFillControls });
    };

    triggerOnChange = () => {
        if (this.props.onChange) {
            this.props.onChange(this.props.queue[this.state.currentIndex]);
        }
    };

    render() {
        const { queue, onEdit } = this.props;

        if (!queue.length) {
            return <div>Cant find the document</div>;
        }

        const index = this.state.currentIndex;
        const idocument = queue[index];
        const total = queue.length;
        const ext = utils.getExtensionFromFilename(idocument.name);
        const isVideo = isVideoExtension(ext);
        const canEdit = kuura.hasPrivilege('PROJECT_W');
        const canDownload = kuura.hasPrivilege('Download_Model');
        const hasLocation = idocument.geographicPoint?.lon && idocument.geographicPoint?.lon !== 0;
        const canFillPdf = true;

        return (
            <>
                <div className='floating-window-toolbar document-popup-toolbar'>
                    {total > 1 && (
                        <>
                            <div id='document-popup-prev' className={cs('toolbar-btn')} onClick={this.goPrev}>
                                <i className='iki iki-chevron-left'></i>
                            </div>
                            <div id='document-popup-next' className={cs('toolbar-btn')} onClick={this.goNext}>
                                <i className='iki iki-chevron-right'></i>
                            </div>
                        </>
                    )}
                    <div className='toolbar-btn doc-popup-counts flex-row ai-center' onClick={this.toggleQueueThumbnails}>
                        {index + 1} / {total}{' '}
                        {queue.length > 1 && <i style={{ marginLeft: 10 }} className='iki iki-grid' title='Showing images at selected location, cluster  or folder' />}
                    </div>

                    {/*{canFillPdf && <Button element='div' tooltip={__('general.fill-form')} icon='iki iki-files' className='toolbar-btn' onClick={this.toggleFillControls} />}*/}
                    {canEdit ? (
                        <Button
                            element='div'
                            tooltip={__('general.edit')}
                            icon='iki iki-edit'
                            className='toolbar-btn'
                            id='image-popup-edit'
                            onClick={() => this.props.onEdit(idocument)}
                        />
                    ) : null}
                    {hasLocation ? (
                        <Button
                            element='div'
                            tooltip={__('general.locate_on_map')}
                            icon='iki iki-map-pin'
                            className='toolbar-btn'
                            id='image-popup-center'
                            onClick={() => this.props.onCenter(idocument)}
                        />
                    ) : null}
                    {ext === 'pdf' && !idocument.url && (
                        <Button
                            element='div'
                            tooltip={__('js_files.open_pdf_in_new_tab')}
                            icon='iki iki-fullscreen'
                            className='toolbar-btn'
                            onClick={() => window.open(kuura.getContextPath() + '/api/1/file/' + idocument.id + '/get?inline=true', '_blank')}
                        />
                    )}
                    {canDownload && !idocument.url && (
                        <Button
                            element='div'
                            tooltip={__('general.download')}
                            icon='iki iki-download'
                            className='toolbar-btn'
                            onClick={() => {
                                Telemetry.add(TelemetryEventType.MAP_DOC_POPUP_DOWNLOAD, TelemetrySource.MAP_2D_DESKTOP);
                                window.open(kuura.getContextPath() + '/api/1/file/' + idocument.id + '/get');
                            }}
                        />
                    )}
                </div>

                {this.state.showQueueThumbnails && (
                    <div className='flex-column of-h'>
                        <DocumentsImagesPanelThumbnails
                            type='documents'
                            items={queue}
                            unfilteredItems={queue}
                            canEdit={false}
                            canSelect={false}
                            canDownload={false}
                            focusItemId={idocument.id}
                            onClick={this.setIndexById}
                        />
                    </div>
                )}

                {(ext === 'pdf' || ext === 'txt' || idocument.url) && (
                    <PdfOrExternalViewer
                        hidden={this.state.showQueueThumbnails}
                        idocument={idocument}
                        infoPosition={null}
                        showFillControls={this.state.showFillControls}
                        showFillSuccessMessage={true}
                        onOpenDocumentUuid={this.props.onOpen}
                    />
                )}

                {ext === 'docx' && (
                    <div className='of-a' style={{ display: this.state.showQueueThumbnails ? 'none' : 'flex', flexGrow: 1 }}>
                        <DocxViewer document={idocument} />
                    </div>
                )}

                {isVideo && (
                    <div className='of-a' style={{ display: this.state.showQueueThumbnails ? 'none' : 'flex', flexGrow: 1 }}>
                        <VideoViewer documentUuid={idocument.uuid} height='100%' />
                    </div>
                )}

                <div style={{ display: this.state.showQueueThumbnails ? 'none' : 'initial', overflow: 'auto', flexShrink: 0, maxHeight: 150, minHeight: 50 }}>
                    <DocumentInfoPanel
                        idocument={idocument}
                        folderTreeNode={this.props.getFolderTreeNode(idocument.folderId)}
                        goToFolder={id => this.props.onOpenFolderId(id, idocument.id)}
                    />

                    {!idocument.url && !isVideo && (
                        <div style={{ textAlign: 'left', margin: '0 0 5px 15px' }}>
                            <DocumentPropertiesList doc={idocument} canEdit={canEdit} />
                        </div>
                    )}
                </div>
            </>
        );
    }
}
